export default "__VITE_ASSET__C_ZjQMD5__"